var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33268H15C15.442 3.33268 15.8659 3.50828 16.1785 3.82084C16.4911 4.1334 16.6667 4.55732 16.6667 4.99935V16.666C16.6667 17.108 16.4911 17.532 16.1785 17.8445C15.8659 18.1571 15.442 18.3327 15 18.3327H4.99999C4.55797 18.3327 4.13404 18.1571 3.82148 17.8445C3.50892 17.532 3.33333 17.108 3.33333 16.666V4.99935C3.33333 4.55732 3.50892 4.1334 3.82148 3.82084C4.13404 3.50828 4.55797 3.33268 4.99999 3.33268H6.66666M7.5 1.66602H12.5C12.9602 1.66602 13.3333 2.03911 13.3333 2.49935V4.16602C13.3333 4.62625 12.9602 4.99935 12.5 4.99935H7.5C7.03976 4.99935 6.66666 4.62625 6.66666 4.16602V2.49935C6.66666 2.03911 7.03976 1.66602 7.5 1.66602Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.4699fa45eac32ab2a2211b7dd8a18a7d.svg";
export { ForwardRef as ReactComponent };